export const InputStatusColors = {
    DEFAULT: '#D7D7D7',
    GREEN: '#45AE06',
    RED: '#C40606'
};

export const InputStatusBGColors = {
    DEFAULT: '#FFFDF4',
    GREEN: '#FFFDF4',
    RED: '#FFF3F3',
    DISABLED: '#F7F7F7'
};

export const DefaultInputStatus = () => {
    return {
        statusMessage: undefined,
        statusColor: InputStatusColors.DEFAULT,
        statusBGColor: InputStatusBGColors.DEFAULT
    };
};

export const SuccessInputStatus = () => {
    return {
        statusMessage: undefined,
        statusColor: InputStatusColors.GREEN,
        statusBGColor: InputStatusBGColors.GREEN
    };
};

export const ErrorInputStatus = (statusMsg) => {
    return {
        statusMessage: statusMsg,
        statusColor: InputStatusColors.RED,
        statusBGColor: InputStatusBGColors.RED
    };
};

export const accountFilter = (campaign) => {
    const accountIds = [];
    if (campaign.advertiserAccountId) {
        accountIds.push(campaign.advertiserAccountId);
    }

    if (campaign.agencyAccountId) {
        accountIds.push(campaign.agencyAccountId);
    }

    return {
        revenueTypeId: campaign.revenueTypeId,
        advertiserId: campaign.advertiserAccountId,
        agencyId: campaign.agencyAccountId,
        campaignId: campaign.id,
        startDate: campaign.startDate,
        endDate: campaign.endDate,
        dealVersionId: campaign.dealVersionId
    };
};

export const campaignBriefInputState = (campaign) => {
    const state = { stepCompleted: true, stepEdited: false };

    if (campaign.id === window.emptyGuid) {
        state.stepCompleted = false;
    } else {
        state.stepEdited = true;
    }

    if (!campaign.name) {
        state.stepCompleted = false;
    } else {
        state.stepEdited = true;
    }

    if (!(campaign.startDate || campaign.endDate)) {
        state.stepCompleted = false;
    } else {
        state.stepEdited = true;
    }

    if (campaign.dealVersionId === window.emptyGuid) {
        state.stepCompleted = false;
    } else {
        state.stepEdited = true;
    }

    if (
        campaign.advertiserAccountId === window.emptyGuid &&
        campaign.agencyAccountId === window.emptyGuid
    ) {
        state.stepCompleted = false;
    } else {
        state.stepEdited = true;
    }

    if (!campaign.productCategoryId) {
        state.stepCompleted = false;
    } else {
        state.stepEdited = true;
    }
    /* PONumbers required for booking not planning */
    /*
    if (
        !campaign.poNumbersJson.single &&
        campaign.poNumbersJson.multiple.filter((mpo) => mpo.poNumber).length ===
            0
    ) {
        state.stepCompleted = false;
    } else {
        state.stepEdited = true;
    }

    */

    // ToDo: add any further checks required

    return state;
};

export const goalUIStructure = (campaignGoal) => {
    if (campaignGoal) {
        return [
            {
                sectionTitle: window.translate('Standard'),
                id: window.translate('Standard'),
                inputA: campaignGoal[
                    campaignGoal.findIndex((g) => g.goal === 'budget')
                ],
                inputB: campaignGoal[
                    campaignGoal.findIndex((g) => g.goal === 'weeklyBudget')
                ]
                // This will be needed again for ROI and Bauer
                // inputB: campaignGoal[
                //     campaignGoal.findIndex((g) => g.goal === 'spotsPerWeek')
                // ]
            },
            //Got the ticket ASSP-4206 to remove Reach % but It might be needed in future if Jim needed
            // {
            //     sectionTitle: window.translate('Reach %'),
            //     id: window.translate('Reach'),
            //     inputA: campaignGoal[
            //         campaignGoal.findIndex((g) => g.goal === 'targetReach')
            //     ],
            //     inputB: campaignGoal[
            //         campaignGoal.findIndex((g) => g.goal === 'baseReach')
            //     ],
            //     symbolA: '%',
            //     symbolB: '%'
            // },
            {
                sectionTitle: window.translate('Weekly OTH'),
                id: window.translate('Weekly-oth'),
                inputA: campaignGoal[
                    campaignGoal.findIndex((g) => g.goal === 'weeklyTargetOTH')
                ],
                inputB: campaignGoal[
                    campaignGoal.findIndex((g) => g.goal === 'weeklyBaseOTH')
                ]
            },
            {
                sectionTitle: window.translate('Overall OTH'),
                id: window.translate('Overall-oth'),
                inputA: campaignGoal[
                    campaignGoal.findIndex((g) => g.goal === 'overallTargetOTH')
                ],
                inputB: campaignGoal[
                    campaignGoal.findIndex((g) => g.goal === 'overallBaseOTH')
                ]
            },
            {
                sectionTitle: window.translate('Impacts (’000)'),
                id: window.translate('Impacts'),
                inputA: campaignGoal[
                    campaignGoal.findIndex((g) => g.goal === 'targetImpacts')
                ],
                inputB: campaignGoal[
                    campaignGoal.findIndex((g) => g.goal === 'baseImpacts')
                ]
            }
        ];
    }
};
